import { useGlobalSearchParams } from "expo-router";
import { useMemo } from "react";
import { CalendarForm } from "~/components/form/calendar/CalendarForm";
import { Dismiss } from "~/components/permission/Dismiss";
import { useDismiss } from "~/providers/DismissProvider";
import { useJournal } from "~/providers/JournalProvider";

export default function EditJournal() {
    const { id }: { id: string } = useGlobalSearchParams();
    const { handleDismiss } = useDismiss();
    const { findPrimaryEvent, canUpdateCalendar } = useJournal();

    const event = useMemo(() => findPrimaryEvent(id), [id, findPrimaryEvent]);

    if (!event || !canUpdateCalendar()) {
        return <Dismiss />;
    }

    return <CalendarForm onRequestClose={handleDismiss} event={event} asRoute />;
}
